import { Box, ChipProps } from '@mui/joy';

import { ColoredChip } from './ColoredChip';
import TextEllipsis from './TextEllipsis';

interface IProps extends ChipProps {
  values: string[];
}

export const ColoredChipList = ({ values, sx, ...props }: IProps) => {
  return (
    <TextEllipsis
      content={
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            padding: '4px 0',
            gap: '8px',
          }}
        >
          {values.map((value: string, index: number) => (
            <ColoredChip key={`${value}-${index}`} value={value} sx={sx} {...props} />
          ))}
        </Box>
      }
      lineHeight={32}
      maxRows={3}
      showMoreLabel
    />
  );
};
